import React from "react";
import { Text } from "@uhg-abyss/web/ui/Text";
import { Flex } from "@uhg-abyss/web/ui/Flex";
import { PageSize, Pagination } from "@uhg-abyss/web/ui/Pagination";
import { recordsPerPageOptions } from "@src/routes/SearchImproved/SearchImproved";

export type CboSearchPaginationTopBarProps = {
  totalRecords: number;
  currentPage: number;
  recordsPerPage: number;
  onPageChange: (changedTo: number) => void;
  onRecordsPerPageChange: (changedTo: typeof recordsPerPageOptions[number]) => void;
};

export function CboSearchPaginationTopBar({
  totalRecords,
  recordsPerPage,
  currentPage,
  onPageChange,
  onRecordsPerPageChange,
}: CboSearchPaginationTopBarProps): React.JSX.Element {
  const showingText = `Showing ${(currentPage - 1) * recordsPerPage + 1} to ` +
   `${Math.min((currentPage) * recordsPerPage, totalRecords)} of ${totalRecords} results`;

  return (
    <React.Fragment>
      <Flex
        justify="space-between"
        alignItems="center"
        data-cy="cbo-search-pagination-top-bar-root"
      >
        <Text
          fontWeight="bold"
          size="$lg"
          data-cy="cbo-search-pagination-top-bar-showing-text"
        >
          { showingText }
        </Text>

        <Flex justify="flex-end">
          <PageSize
            // Conversion is necessary because this component doesn't like the readonly array
            pageSizeOptions={(recordsPerPageOptions as unknown) as number[]}
            pageSize={recordsPerPage}
            setPageSize={(next: typeof recordsPerPageOptions[number]) => {
              onRecordsPerPageChange(next);
            }}
            css={{
              'abyss-pagination-page-size-root': {
                fontWeight: 'bold',
                paddingRight: '8px',
              },
              'abyss-pagination-page-size-label': {
                fontSize: 'large',
              },
            }}
          />

          <Pagination
            data-cy="cbo-search-pagination-top-bar-pagination"
            pageIndex={currentPage - 1}
            pageCount={Math.ceil(totalRecords / recordsPerPage)}
            canPreviousPage={recordsPerPage * (currentPage - 1) > 0}
            canNextPage={currentPage < Math.ceil(totalRecords / recordsPerPage)}
            variant="compact"
            gotoPage={(page: number) => {return onPageChange(page)}}
            previousPage={() => {return onPageChange(currentPage - 1)}}
            nextPage={() => {return onPageChange(currentPage + 1)}}
          />
        </Flex>
      </Flex>
    </React.Fragment>
  );
}

